import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PatchedStandardRecordRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateStandardRecordMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.standardRecordsCreate,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateStandardRecordMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, ...payload }: { id: number } & PatchedStandardRecordRequest) =>
      SSF.api.standardRecordsPartialUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteStandardRecordMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.standardRecordsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
